import React from "react";

function Plot_Chartjs() {
  return (
    <div>
      <h1>Plot_Chartjs Component</h1>
      <p>This is the Plot Chartjs tutorial page content.</p>
    </div>
  );
}

export default Plot_Chartjs;
